import { SectionLabel } from './ui';

export function About() {
  return (
    <section className="about-section section-space" id="about" aria-labelledby="about-heading">
      <div className="container about-grid">
        <div className="about-heading">
          <SectionLabel number="02">Background</SectionLabel>
          <h2 id="about-heading">About Me</h2>
        </div>
        <div className="about-copy">
          <p className="about-lead">I'm Maycie, a front-end web developer who enjoys both the creative and technical sides of building websites.</p>
          <p>Since 2022, I've been the front-end developer at Stickley, where I work on everything from custom storefront features and design improvements to third-party integrations and troubleshooting.</p>
          <p>What I enjoy most about development is the problem-solving. I like figuring out how things work, finding better ways to do them, and turning ideas into something functional. I'm comfortable working independently, but I also enjoy collaborating with others to bring a project together.</p>
          <p>Outside of my full-time role, I'm open to freelance opportunities involving front-end development, e-commerce, and custom website functionality.</p>
        </div>
      </div>
    </section>
  );
}
